/**
 * Shared classifier for lazy-chunk/preload failures.
 *
 * These errors are NOT retryable in place: React caches a rejected lazy(),
 * and Chromium's module map re-rejects a same-URL import() without refetching
 * (verified empirically — zero new network requests on retry). Vite's preload
 * helper produces the CSS variant when a chunk's stylesheet dependency fails.
 * Every error boundary above lazy content must offer a page Reload for these,
 * never an in-place "Try Again".
 */
const CHUNK_LOAD_ERROR =
  /Failed to fetch dynamically imported module|error loading dynamically imported module|Importing a module script failed|Unable to preload CSS/i;

export function isChunkLoadError(error: unknown): boolean {
  const message =
    error instanceof Error ? error.message : typeof error === 'string' ? error : '';
  return CHUNK_LOAD_ERROR.test(message);
}
